import { Trans } from '@lingui/react'

import {
  ButtonGroup,
  InlineButton,
  TextButton,
} from '@twisto/components/atoms/button'
import {
  Headline,
  HeadlineIcon,
  HeadlineSubtitle,
  HeadlineTitle,
} from '@twisto/components/atoms/headline'
import {
  Modal,
  ModalContent,
  ModalNavigation,
} from '@twisto/components/atoms/modal'
import { BigWarningIcon } from '@twisto/icons'

import * as styles from './pep-confirmation-modal.styles'

type Props = {
  opened: boolean
  onClose: () => void
  onConfirm: () => void
  onPepDescriptionOpen: () => void
}
const modalTitleId = 'id-modal-title-pepConfirmationModal'

export const PepConfirmationModal = ({
  opened,
  onClose,
  onConfirm,
  onPepDescriptionOpen,
}: Props) => (
  <Modal
    noPadding
    aria-labelledby={modalTitleId}
    modalWrapperStyles={styles.modalWrapper}
    opened={opened}
    onClickOutside={onClose}
  >
    <ModalNavigation
      modalCloser={{ onClick: onClose }}
      title={<Trans id="flow.pepConfirmationModal.title" />}
      titleId={modalTitleId}
    />
    <ModalContent css={styles.modalContent}>
      <Headline>
        <HeadlineIcon>
          <BigWarningIcon color="warning" height="100%" width="100%" />
        </HeadlineIcon>
        <HeadlineTitle>
          <Trans id="flow.pepConfirmationModal.headline.title" />
        </HeadlineTitle>
        <HeadlineSubtitle>
          <Trans id="flow.pepConfirmationModal.headline.subtitle" />
        </HeadlineSubtitle>
      </Headline>
      <InlineButton
        css={styles.pepDescriptionButton}
        onClick={onPepDescriptionOpen}
      >
        <Trans id="flow.pepConfirmationModal.pepDescription.link" />
      </InlineButton>
      <ButtonGroup css={styles.buttonGroup}>
        <TextButton fullWidth color="secondary" onClick={onConfirm}>
          <Trans id="flow.pepConfirmationModal.buttonGroup.confirm" />
        </TextButton>
        <TextButton fullWidth onClick={onClose}>
          <Trans id="flow.pepConfirmationModal.buttonGroup.back" />
        </TextButton>
      </ButtonGroup>
    </ModalContent>
  </Modal>
)
